import React, { useState, useEffect, useContext } from 'react';
// import AppImage from '../AppImage';

import styles from './styles.module.scss';

import Api from '../../api';
import { AdminContext } from '../../context/AdminContext';

import SHARED from '../../constants';

import UploadVideoForm from '../UploadVideoForm';
import FileUpload from '../FileUpload';
import Loader from '../Loader';

import HelpBox from '../HelpBox';
import LoadingImage from './loadingImage';
// import VideoCutTool from '../VideoCutTool';
// import { AppContext } from '../../context/VideoCutContext';
import { clearItems } from '../../utils/storage';
import UploadVideoMoreInfo from '../UploadVideoMoreInfo';
import checkCircle from '../../../../assets/imgs/login/checkCircle.svg';
import AppMessage from '../AppMessage';

const UploadingVideoModal = ({
  closeModal,
  progressValue,

  uploadResponse,
  videoInformation,
  setVideoInformation,
  handleChangeInformation,
  loadingCrop,
  setloadingCrop,
  ifMusic,
  setIfMusic,
  activeMenu,
  setActiveMenu,
  emptyVideo,
  content,
  uploadedImage,
  setUploadedImage,
  emptyUploadedImage,
}) => {
  const {
    login,
    privateUser,
    setPrivateUser,
    newVideoCreated,
    // setNewVideoCreated,
    setNotificationText,
    // setopenNotificationModalSuccess,
    // setopenNotificationModalError,
    themeColor,
    setTrigger,
    modalInputValue,
    musicExtension,
  } = useContext(AdminContext);
  console.log("content====", content)
  const { updateAppState, appState } = useContext(AdminContext);

  const [inputValue, setModalInputValue] = useState('0%');

  const [chosenImage, setChosenImage] = useState('');
  const [chosenImageAddress, setChosenImageAdress] = useState('');

  const [selectedFile, setSelectedFile] = useState(null);

  const [videoSrc, setVideoSrc] = useState('');
  const [pressed, setPressed] = useState(false);
  const [openInfoCover, setOpenInfoCover] = useState(false);
  const [uploadedImageChosen, setUploadedImageChosen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [finalResult, setFinalResult] = useState({});
  const [serverMessage,setServerMessage]= useState('');
  // const [uploadedImage, setUploadedImage] = useState({
  //   status: '',
  //   message: '',

  //   response: {
  //     fileId: '',
  //     cover: {
  //       filename_1: '',
  //       filename_2: '',
  //       filename_3: '',
  //       filename_4: '',
  //       filename_5: '',
  //     },
  //     token: '',
  //     name: '',
  //     nameThumbnail: '',
  //     serverId: '',
  //   },
  // });

  // const [activeMenu, setActiveMenu] = useState(1);
  const [dummyEditorState, setDummyEditorState] = useState(
    videoInformation?.content?.value
  );
  const [srtFileName, setSrtFileName] = useState({ name: '', id: '' });
  const [musicFileName, setMusicFileName] = useState({ name: '', id: '' });

  const [loadingImageUpload,setLoadingImageUpload]=useState(false);

  // useEffect(() => {
  //   setDummyEditorState(videoInformation?.content?.value);
  // }, [videoInformation?.content?.value]);

  useEffect(() => {
    setVideoInformation({
      ...videoInformation,
      userIds: privateUser.ids,
      privateUserContent: privateUser.content,
    });
  }, [privateUser]);

  useEffect(() => {
    if (videoInformation.videoId) {
      setUploadedImage({
        status: '',
        message: '',
        data: {
          response: {
            name: videoInformation.image.name,
            fileId: videoInformation.image.value,
          },
        },
      });
    }
  }, [videoInformation.videoId]);

  useEffect(() => {
    const value = Math.round(
      (progressValue / videoInformation?.file?.size) * 100
    );

    setModalInputValue(value);
  }, [progressValue]);

  useEffect(() => {
    if (selectedFile !== null) {
      uploadVideoFunction();
    }
  }, [selectedFile]);

  const uploadVideoFunction = () => {
    setPressed(false);
    if (login) {
      const formData = new FormData();
      formData.append('file', selectedFile);
// const
setLoadingImageUpload(true)
      Api.uploadUserImage(formData, '?type=videoCover')
        .then((res) => {
          setLoadingImageUpload(false);
          setUploadedImage(res);
        })
        .catch((err) => {
          setLoadingImageUpload(false);
          setServerMessage(err.response.data.message);
          // setopenNotificationModalError(true);
          // setNotificationText({
          //   title: 'آپلود عکس کاور ویدیو',
          //   description: err.response.data.message,
          // });
        });
    } else {
      setShowModal(true);
    }
  };
  const videosInsert = (array, submitMode) => {
    if (submitMode) {
      setLoadingSubmit(true);
    } else {
      setLoading(true);
    }

    Api.userVideosInsert(array, videoInformation.videoId)
      .then((res) => {
        setLoadingSubmit(false);
        setLoading(false);
        setPressed(false);
        // setPrivateUser({ ids: [], content: '' });
        setChosenImage('');
        setChosenImageAdress('');
        // setTrigger('refreshMyVideo');
        // setNewVideoCreated(!newVideoCreated);
        setVideoInformation(emptyVideo)
        setActiveMenu(2)
        closeModal();
        // setopenNotificationModalSuccess(true);
        // setNotificationText({
        //   title: 'انتشار ویدیو',
        //   description: res.data.message,
        // });
      })
      .catch((err) => {
        setPressed(false);
        setLoadingSubmit(false);
        setLoading(false);
        setServerMessage(err.response.data.message);

        // setopenNotificationModalError(true);
        // setNotificationText({
        //   title: 'انتشار ویدیو',
        //   description: err.response.data.message,
        // });
      });
  };

  const saveFunction = (submitMode = true) => {
    // setLoadingSubmit(submitMode);
// alert("1")
    // setLoading(!submitMode);

    if (!pressed) {
      //  let array = { ...videoInformation, status_id: submitMode ? 1 : 3 };

      let array = {
        name: videoInformation.name.value,
        image_id: videoInformation.image.value,
        // age_class_id: videoInformation.age.value,
        token: videoInformation.file.token,
        // playlist_ids: videoInformation.playlists.value,
        // privateUserContent: '',
        // category_id: videoInformation.category.value,
        content: videoInformation.content.value,
        // content: dummyEditorState,
        file_id: videoInformation.file.value,
        // file_srt_id: videoInformation?.file_srt_id,
        // userIds: [],
        // child_content: videoInformation?.child_content,
        // comment_status_id: videoInformation.comment.value,
        // status_id: submitMode ? 1 : 3,
        // user_status_id: '1',
        // watermark: 0,
        // channelId: videoInformation.channel.value,
        keywords: videoInformation.keywords.value,
        // priceType: videoInformation?.priceType,
        // typeId: videoInformation?.typeId,
        // musicName: videoInformation?.musicName,
      };

      if (checkError()) {

        setLoading(false);
        setLoadingSubmit(false);
        setActiveMenu(1);
        setPressed(false);

      } else {
 
        // setPressed(false);
        // setLoading(false);

        // console.log('array', array);
        // return;
        setPressed(true);
        // alert("2")
        if (chosenImage?.length == 0) {
          videosInsert(array, submitMode);
        } else {
          Api.sendThumbnail({ imageName: chosenImageAddress })
            .then((res) => {
              array = { ...array, image_id: res.data.response.fileId };
              videosInsert(array, submitMode);
            })
            .catch(() => {
              setPressed(false);
              // setopenNotificationModalError(true);
              setLoading(false);
              setServerMessage(err.response.data.message);
              // setActiveMenu(2)
              // setNotificationText({
              //   title: submitMode ? 'انتشار ویدیو' : 'ذخیره ویدیو',
              //   description: err.response.data.message,
              // });
            });
        }
      }
    } else {
      setLoadingSubmit(false);
      setLoading(false);
    }
  };
  const chooseCoverFromThumbnail = (id, image) => {
    setUploadedImageChosen(false);
    setPressed(false);

    handleChangeInformation('image', {
      ...videoInformation.image,
      value: '',
    });
    if (image.length !== 0) {
      handleChangeInformation('image', {
        ...videoInformation.image,
        errorTitle: false,
      });
      setChosenImageAdress(image);
      if (chosenImage !== id) {
        setChosenImage(id);
      } else {
        setChosenImage('');
        setChosenImageAdress('');
      }
    }
  };
  const chooseUploadedImage = (id, image) => {
    console.log(
      'chosenimage',
      id,
      image,
      uploadedImage?.data?.response?.fileId,
      uploadedImageChosen
    );
    setPressed(false);
    setUploadedImageChosen(!uploadedImageChosen);
    // if (id == undefined && modalInputValue?.name?.length != 0) {
    //   handleChangeInformation('image', {
    //     ...videoInformation.image,
    //     value: videoInformation?.image?.value,
    //     image_id: videoInformation?.image?.value,
    //   });
    // } else {
    handleChangeInformation('image', {
      ...videoInformation.image,
      value: !uploadedImageChosen ? id : '',
    });
    // }

    setChosenImage('');
  };
console.log("chosenimage", chosenImage)
  const checkError = () => {
    let result = false;
    setLoading(false);
    setLoadingSubmit(false);

    if (videoInformation?.name?.value?.trim().length == 0) {
      result = true;
    }
    if (
      videoInformation.content.value.trim().length == 0 
        
    ) {
      result = true;
    }

    // if (dummyEditorState == '<p><br></p>' || dummyEditorState?.length == 0){
    //   result = true;
    // }
    if (
      videoInformation?.image?.value?.length == 0 &&
      chosenImage.length == 0
    ) {
      result = true;
    }
    if (videoInformation.file.value.length == 0) {
      result = true;
    }

    setVideoInformation({
      ...videoInformation,
      name: {
        ...videoInformation.name,
        errorTitle: videoInformation.name.value.trim().length == 0,
      },
      content: {
        ...videoInformation.content,
        errorTitle:
          videoInformation.content.value.trim().length == 0 ,
      },
      // content: {
      //   ...videoInformation.content,
      //   errorTitle: dummyEditorState.trim().length == 0 || dummyEditorState== '<p><br></p>',
      // },
      file: {
        ...videoInformation.file,
        errorTitle: videoInformation.file.value.length == 0,
      },
      image: {
        ...videoInformation.image,
        errorTitle:
          videoInformation?.image?.value?.length == 0 &&
          chosenImage.length == 0,
      },
      // category: {
      //   ...videoInformation.category,
      //   errorTitle: videoInformation.category.value.length == 0,
      // },
    });
    return result;
  };
  const [videoCroped, setVideoCroped] = useState(false);
  useEffect(() => {
    if (
      videoInformation?.image?.value?.length !== 0 ||
      chosenImage?.length !== 0
    ) {
      handleChangeInformation('image', {
        ...videoInformation.image,
        errorTitle: false,
      });
    }
  }, [videoInformation?.image?.value]);

  useEffect(() => {
    if (videoInformation?.file?.name?.length !== 0) {
      handleChangeInformation('file', {
        ...videoInformation.file,
        errorTitle: false,
      });
      // setIfMusic(
      //   musicExtension?.findIndex(
      //     (x) => x.name == videoInformation?.file?.name?.split('.')?.[1]
      //   ) != -1
      //     ? true
      //     : false
      // );
      const musicFile = false;
        // musicExtension?.findIndex(
        //   (x) => x.name == videoInformation?.file?.name?.split('.')?.[1]
        // ) != -1
        //   ? true
        //   : false;
      console.log('ifMusic', ifMusic, musicFile, musicExtension);
      if (musicFile) {
        setVideoSrc(
          `https://api2.ochatt.com/musics/${videoInformation?.file?.name}`
        );
      } else {
        setVideoSrc(
          `https://api2.ochatt.com/videos/${videoInformation?.file?.name}`
        );
      }
      if (videoCroped) {
        updateAppState({
          current_step: 2,
          video_url: musicFile
            ? `https://api2.ochatt.com/musics/${videoInformation?.file?.name}`
            : `https://api2.ochatt.com/videos/${videoInformation?.file?.name}`,
          file: videoInformation?.file,
          video_details: {
            title: videoInformation?.file?.name?.replace(/\s/g, '_'),
          },
        });
        clearItems([
          'video-manipulations',
          'video-settings',
          'video-trim-hash',
          'video-trims',
          'video-crop',
        ]);
        setVideoCroped(false);
      }
      setloadingCrop(false);
    }
  }, [videoInformation?.file?.name]);

  useEffect(() => {}, [appState]);

  // useEffect(() => {
  //   setFinalResult('1');
  //   if (!appState?.file?.name?.includes('/u/')) {
  //     setVideoSrc(`https://api2.ochatt.com/videos/${appState?.file?.name}`);
  //   } else {
  //     setVideoSrc(`https://api.clipsho.com${appState?.file?.name}`);
  //   }
  // }, [appState]);
  // let ifMusic = musicExtension?.findIndex((x) =>
  //   (x.name == videoInformation?.file?.name?.split('.')?.[1]) != -1
  //     ? true
  //     : false
  // );
  console.log(
    'video',
    videoInformation,
    uploadedImage,
    uploadedImage?.data?.response?.fileId,
    videoSrc,
    videoInformation?.file?.name?.split('.')?.[1],
    ifMusic
  );

  useEffect(()=>{
    if (serverMessage?.length != 0){
      setTimeout(()=>{
        setServerMessage('')
      },3000)
    }
  },[serverMessage])
  return (
    <div className={styles.container}>
      {serverMessage && 
            <AppMessage
        Message={serverMessage}
        RequareMessageforChangeBg='درخواست با موفقیت ثبت شد'
      />}
      <div className={styles.information}>
        {/* <UploadVideoForm
          handleChange={handleChangeInformation}
          videoInformation={videoInformation}
          setPressed={setPressed}
          setVideoInformation={setVideoInformation}
        />
      </div> */}
        {/* <div
          className={`flex flex-row justify-start items-center w-full mb-20px`}
        >
          <p
            onClick={() => {
              setActiveMenu(1);
            }}
            className={
              activeMenu == 1
                ? `${styles.activeMenu} preserveWhiteThemeColor`
                : styles.unActiveMenu
            }
          >
            {' '}
            اطلاعات ویدیو
          </p>
          {!ifMusic && (
            <p
              onClick={() => {
                setActiveMenu(2);
              }}
              className={
                activeMenu == 2
                  ? `${styles.activeMenu} preserveWhiteThemeColor`
                  : styles.unActiveMenu
              }
            >
              {' '}
              ویدیو ادیتور{' '}
              <span className={styles.experimental}>(آزمایشی)</span>
            </p>
          )}
          {!modalInputValue?.name && (
            <p
              onClick={() => {
                setActiveMenu(3);
              }}
              className={
                activeMenu == 3
                  ? `${styles.activeMenu} preserveWhiteThemeColor`
                  : styles.unActiveMenu
              }
            >
              جزییات بیشتر
            </p>
          )}
        </div> */}
        {/* {activeMenu == 1 && (
          <UploadVideoForm
            handleChange={handleChangeInformation}
            videoInformation={videoInformation}
            setPressed={setPressed}
            setVideoInformation={setVideoInformation}
            dummyEditorState={dummyEditorState}
            setDummyEditorState={setDummyEditorState}
            editMode={modalInputValue?.name}
          />
        )} */}

        {/* {activeMenu == 2 && (
          <>
            {loadingCrop == false ? (
              <VideoCutTool
                videoInformation={videoInformation}
                setVideoInformation={setVideoInformation}
                setActiveMenu={setActiveMenu}
                setloadingCrop={setloadingCrop}
                finalResult={finalResult}
                setFinalResult={setFinalResult}
                activeMenu={activeMenu}
                setVideoCroped={setVideoCroped}
              />
            ) : (
              <Loader width={`w-full`} height={`h-200px`} />
            )}
          </>
        )} */}
        {/* {activeMenu == 3 && (
          <UploadVideoMoreInfo
            ifMusic={ifMusic}
            handleChange={handleChangeInformation}
            videoInformation={videoInformation}
            setPressed={setPressed}
            setVideoInformation={setVideoInformation}
            dummyEditorState={dummyEditorState}
            setDummyEditorState={setDummyEditorState}
            editMode={modalInputValue?.name}
            srtFileName={srtFileName}
            setSrtFileName={setSrtFileName}
            musicFileName={musicFileName}
            setMusicFileName={setMusicFileName}
          />
        )} */}
      </div>
      <div
        className={`${styles.sidebar} ${
          themeColor != 'white' && 'borderBlackRight'
        }`}
      >
        {!videoInformation.videoId && (
          <>
            <div
              className={`${styles.videoContainer} ${
                ifMusic ? styles.musicBg : styles.videoBg
              }`}
              style={{ aspectRatio: videoSrc?.length == 0 ? '1.6' : 'unset' }}
            >
               {videoSrc?.length == 0 ? ( 
                <div className={styles.absoluteBoxLoadingContainer}>
                  {videoInformation?.file?.name.length == 0 && (
                    <div className={styles.absoluteBoxLoading}>
                      <span className={styles.text}>
                       {content?.isUploading}
                        </span>
                      <div className={styles.number}>
                        <span>
                          {(progressValue / 1048576).toFixed(2)} {content?.megaByte}{' '}
                        </span>
                        {content?.from}{' '}
                        <span>
                          {(videoInformation?.file?.size / 1048576).toFixed(2)}
                        </span>{' '}
                        {content?.megaByte}
                      </div>
                      <div className={styles.inputBox}>
                        <div
                          className={styles.progress}
                          style={{ width: `${inputValue}%` }}
                        ></div>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <>
                  {ifMusic ? (
                    <div className={styles.audioBox}>
                      <audio
                        controls
                        // controls='volume'
                        src={videoSrc}
                        id='uploadVideo'
                        controlsList='nodownload'
                      />
                    </div>
                  ) : (
                    <video
                      className={styles.videoStyle}
                      controls
                      src={videoSrc}
                      id='uploadVideo'
                    />
                  )}
                </>
              )}
            </div>

            {videoInformation?.file?.value &&
            videoInformation?.file?.value.length !== 0 ? (
              <div className={styles.uploadDone}>
                <p className={styles.uploadDoneText}>
                 {content?.videoIsReady}
                </p>
              </div>
            ) : (
              <div className={styles.uploadDone}>
                <p className={`${styles.uploadDoneSize} w-full`}>
                  {(videoInformation?.file?.size / 1048576).toFixed(2)} {content?.megaByte}
                </p>
              </div>
            )}
            {videoInformation?.file?.errorTitle && (
              <p className={styles.error}>
               {content?.proccessing}
                </p>
            )}
                    {activeMenu == 1 && (
          <UploadVideoForm
            handleChange={handleChangeInformation}
            videoInformation={videoInformation}
            setPressed={setPressed}
            setVideoInformation={setVideoInformation}
            dummyEditorState={dummyEditorState}
            setDummyEditorState={setDummyEditorState}
            editMode={modalInputValue?.name}
            content={content?.videoForm}
          />
        )}

            <div
              className={`flex flex-row justify-between items-center w-full h-auto`}
            >
              <p
                className={`${styles.coverTitle} `}
              >
                {content?.chooseCover}
              </p>
              {/* <HelpBox
                openInfoBox={openInfoCover}
                setOpenInfoBox={setOpenInfoCover}
              >
                <div className={`flex flex-col justify-start align-start`}>
                  <p className={styles.switchDescription}>
                    شما می توانید برای ویدیو خود یک تصویر انتخاب کنید یا آپلود
                    نمایید. انتخاب تصویر مناسب می‌تواند در دیده شدن ویدیو شما
                    تاثیرگذار باشد.
                  </p>
                </div>
              </HelpBox> */}
            </div>
            <div className={styles.thumbnailContainer}>
              {videoInformation?.image?.errorTitle && (
                <p className={`${styles.error} w-full preserveWhiteThemeColor`}>
                 {content?.chooseCoverError}
                </p>
              )}
              <LoadingImage
                chooseCoverFromThumbnail={chooseCoverFromThumbnail}
                filename={uploadResponse?.cover?.filename_1}
                id='1'
                seleted={chosenImage == 1}
                content={content}

              />
              <LoadingImage
                chooseCoverFromThumbnail={chooseCoverFromThumbnail}
                filename={uploadResponse?.cover?.filename_2}
                id='2'
                seleted={chosenImage == 2}
                content={content}

              />
              <LoadingImage
                chooseCoverFromThumbnail={chooseCoverFromThumbnail}
                filename={uploadResponse?.cover?.filename_3}
                id='3'
                seleted={chosenImage == 3}
                content={content}
              />
              <LoadingImage
                chooseCoverFromThumbnail={chooseCoverFromThumbnail}
                filename={uploadResponse?.cover?.filename_4}
                id='4'
                seleted={chosenImage == 4}
                content={content}

              />
            </div>
          </>
        )}

        <div
          className={`${styles.buttonContainer} ${
            themeColor != 'white' && 'borderBlackBottom'
          } `}
        >
          <div className={`${styles.button} cursor-pointer w-full`}>
            <FileUpload
              cropMode
              selectedFile={selectedFile}
              setSelectedFile={setSelectedFile}
              loadingStyle={styles.lds_ring}
              height={`h-full `}
            >
              {content?.uploadImage}
            </FileUpload>
          </div>

        </div>

        <div className={`flex flex-col justify-start items-start py-10px `}>
          <p style={{ color: '#d8000d', fontSize: '10px', margin: '5px 0' }}>
           {content?.uploadedImage}
          </p>
          <div
            className={`flex flex-row items-center justify-center w-full h-auto min-h-100px relative ${
              themeColor == 'white' && 'bg-fafafa'
            } ${
              videoInformation?.image_id ==
                uploadedImage?.data?.response?.fileId &&
              uploadedImageChosen &&
              videoInformation?.image_id != undefined
                ? styles.redBorder
                : styles.grayBorder
            }`}
            onClick={() => {
              chooseUploadedImage(
                uploadedImage?.data?.response?.fileId,
                uploadedImage?.data?.response?.name
              );
            }}
          >
            {uploadedImage !== null &&
            uploadedImage?.data?.response?.name != undefined ? (
              <div className={` w-full h-full cursor-pointer`}>
                <img
                  className={`w-full h-auto mx-auto`}
                  // src={`${
                  // videoInformation.videoId
                  //   ? SHARED.IMAGE_URL
                  //   :
                  src={`${
                    // uploadedImage != null &&
                    // uploadedImage?.data?.response?.name != undefined
                    uploadedImage?.data?.response?.fileId != undefined
                      ? SHARED.IMAGE_URL_COPY_API +
                        '/images/' +
                        uploadedImage?.data?.response?.name
                      : SHARED.IMAGE_URL + uploadedImage?.data?.response?.name
                  } `}
                />
                {videoInformation?.image.value ==
                  uploadedImage?.data?.response?.fileId &&
                  uploadedImageChosen && (
                    <div className={styles.imageAbsoluteCover}>
                      <img
                        // src='/imgs/login/checkCircle.svg'
                        src={checkCircle}
                        alt='checked'
                        width={30}
                        height={30}
                      />
                    </div>
                  )}
              </div>
            ) : (
              <>
              {!loadingImageUpload ?
              <p style={{ fontSize: '10px', margin: 'auto 2px' }}>({content?.empty})</p>
:
<Loader
className={styles.lds_ring}
width={`w-20px`}
height={`h-20px`}
/>
              }
              </>
            )}
          </div>
        </div>

        <div className={styles.submitButtonsContainer}>
          <button
            className={`${styles.button} `}
            onClick={() => saveFunction(true)}
          >
                {loadingSubmit ? (
            <p className='relative'>

                <Loader
                  className={styles.lds_ringSubmit}
                  width='w-auto'
                  height='h-auto'
                  // width='w-90 top-60 left-50px absolute'
                  // height='h-full'
                />

            </p>
                )
                :
                (
            <p className='relative'>
              {content?.submit}

            </p>)}
          </button>
          {/* <button
            className={`${styles.button} `}
            onClick={() => saveFunction(false)}
          >
            <p className='relative preserveWhiteThemeColor'>
              ذخیره
              {loading && (
                <Loader
                  className={styles.lds_ringSave}
                  width='w-90 top-60 left-50px absolute'
                  height='h-full'
                />
              )}
            </p>
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default UploadingVideoModal;
